import React, { Component } from 'react';
import CountriesAndStates from './../helper/CountriesAndStates';
import SelectOrgToJoinModal from './modals/SelectOrgToJoinModal';
import OrgNameAlreadyExistsErrorModal from './modals/OrgNameAlreadyExistsErrorModal';
import RequestToJoinOrgErrorMessageModal from './modals/RequestToJoinOrgErrorMessageModal';
import RequestToJoinOrgSuccessMessageModal from './modals/RequestToJoinOrgSuccessMessageModal';
import SubmitUpgradeOrgRequestModal from './modals/SubmitUpgradeOrgRequestModal';
import {loadCsrf} from './../common/CsrfFetcher';
import OrganizationSearch from './../manageOrg/OrganizationSearch';
import {FormError} from './../FormError';
import {loginRedirect} from './../common/Util'
import {errorRedirect} from './../common/Util'
import {pageRedirect} from './../common/Util'

class UpgradePersonalAccountForm extends Component {

	constructor (props) {
		super(props);
		this.state = {
			organizationName:"",
			businessEmail:"",
			webSite:"",
			description:"",
			address1:"",
			address2:"",
			city:"",
			state:"",
			country:"",
			postalCode:"",
			phone:"",
			orgSearchResults:[],
			showSelectOrgToJoinModal:false,
			showRequestToJoinOrgSuccessMessageModal:false,
			showRequestToJoinOrgErrorMessageModal:false,
			requestToJoinOrgErrorMessage:""	,
			organizationNameError:"",
			address1Error:"",
			address2Error:"",
			phoneError:"",
			cityError:"",
			usState:"",
			nonUSState:"",
			countryError:"",
			USStateError:"",
			nonUSStateError:"",
			businessEmailError:"",
			webSiteError:"",
			postalCodeError:"",
			descriptionError:"",
			formErrors: [],
			showSubmitUpgradeOrgRequestModal:false,
			showOrgNameAlreadyExistsErrorModal:false,
			userJoinRequestStatus: ""
		}
  }
	componentDidMount() {
		loadCsrf(this.setCsrfState);
	}

	setCsrfState = (csrfToken, csrfHeaderValue) => {
		var state = this.state;
		state.csrfToken = csrfToken;
		this.csrfHeaderValue = csrfHeaderValue;
		this.setState({
			state
		});
	}

	handleInputChange = (event) => {

		const target = event.target;
		const value = target.value;
		const name = target.name;
		const errorName = name + 'Error';

		this.setState({
			[name]: value,
			[errorName]: ""
		});
		if (value === "" && name === 'organizationName') {

			this.setState({
				organizationNameError: "Error: Please enter a Name.",
			});
		}
		if (value !== "" && name === 'organizationName' && this.state.organizationName !== "") {
			const orgNameRegEx = /^(?=.*?[a-zA-Z0-9])[a-zA-Z0-9-.][A-Za-z0-9- .&*$@#!:;=_?%]*[A-Za-z0-9-.&*$@#!:;=_?%]$/;
			if (!value.match(orgNameRegEx)) {
				this.setState({
					organizationNameError: "Error: Please use only English, alphanumeric characters. Spaces, periods, and these special characters are allowed - & * $ @ # ! : ; = ? _ % (no commas). Other than alphanumeric characters, only . and - are allowed at the beginning. No leading or trailing spaces.",
				});
			}
		}
		if (value === "" && name === 'address1') {
			this.setState({
				address1Error: "Error: Please enter an Address.",
			});
		}
		if (value === "" && name === 'city') {
			this.setState({
				cityError: "Error: Please enter an City.",
			});
		}

		if (value === "" && name === 'phone') {
			this.setState({
				phoneError: "Error: Please enter a Phone Number.",
			});
		}

		if (value === "" && name === 'businessEmail') {
			this.setState({
				businessEmailError: "Error: Please enter a Business Email.",
			});
		}
		if (value !== "" && name === 'businessEmail' && this.state.businessEmail !== "") {
			const phoneNumberRegEx = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
			if (!value.match(phoneNumberRegEx)) {
				this.setState({
					businessEmailError: "Error: Please enter a valid email address.",
				});
			}
		}
		if (value === "" && name === 'description') {
			this.setState({
				descriptionError: "Error: Please enter a Business Description.",
			});
		}
		if (value === "" && name === 'postalCode') {
			this.setState({
				postalCodeError: "Error: Please enter a Postal Code.",
			});
		}
	}


	handleResponseForOrgJoinRequest = (response) => {
		var userJoinRequestStatus = response.status;

		this.setState({
				showSelectOrgToJoinModal: false
		});

		if(response.message === 'dialog_join_request')	{
			this.setState({
				userJoinRequestStatus: userJoinRequestStatus,
				showRequestToJoinOrgSuccessMessageModal: true,
				showRequestToJoinOrgErrorMessageModal: false
			});
		}	else if(response.status === 'redirect' && response.message === 'organizationManage.jsp')	{
			pageRedirect("/developer/mvc/organization/manageUsers");
		}	else{
			this.setState({
				requestToJoinOrgErrorMessage: response.message,
				showRequestToJoinOrgSuccessMessageModal: false,
				showRequestToJoinOrgErrorMessageModal: true
			});
		}
	}

	closeRequestToJoinOrgErrorMessageModal = () => {
		this.setState({
			showRequestToJoinOrgErrorMessageModal: false
		});
	}

	closeRequestToJoinOrgSuccessMessageModal = () => {
		this.setState({
			showRequestToJoinOrgSuccessMessageModal: false
		});
	}

	hideSelectOrgToJoinModal = () => {
		this.setState({
			showSelectOrgToJoinModal: false
		});
	}

	hideSubmitUpgradeOrgRequestModal = () => {
		this.setState({
			showSubmitUpgradeOrgRequestModal:false
		});
	}

	hideOrgNameAlreadyExistsErrorModal = () => {
		this.setState({
			showOrgNameAlreadyExistsErrorModal:false
		});
	}

	handleOnBlurOrgName = (event) => {
		const name = event.target.name;
		if (name === 'organizationName') {
			this.child.searchOrgs(this.state);
		}
	}

	handleOrgSearchResults = (orgSearchResults) => {
		if(orgSearchResults.length > 0)	{
			this.setState({
				orgSearchResults: orgSearchResults,
				showSelectOrgToJoinModal: true
			});
		}
	}

	setSelectedState = (selectedState) => {

        var state = this.state;
		state.usState = selectedState;

        if (selectedState === "Select" || selectedState === "") {
           this.setState({
			USStateError: "Error: Please select a State.",
			});
        } else {
			this.setState({
				USStateError: "",
				nonUSStateError: "",
			});
        }

        this.setState({
            state
		});
	}

    setSelectedNonUSState = (selectedNonUSState) => {

		var state = this.state;
		state.nonUSState = selectedNonUSState;

		state.genericFormLevelProblems='';
        //TODO: Do we need to do this?
		this.validateNonUSState(selectedNonUSState, state);

		this.setState({
			state
		});
	}

	 setSelectedCountry = (selectedCountry) => {

		var state = this.state;
		state.country = selectedCountry;

		if (selectedCountry === "Select" || selectedCountry.includes("---") || selectedCountry === "") {
			this.setState({
				countryError: "Error: Please select a Country.",
			});
		} else if (selectedCountry === "UNITED STATES") {
			state.nonUSState = '';
			state.nonUSStateError= '';
			state.countryError = '';
			this.validateUSState(state.usState, state);
		} else{
			state.countryError = '';
			this.validateNonUSState(state.nonUSState, state);
		}

		this.setState({
			state
		});
	}

	handleReconcileCountryState = () =>{
		//Don't want to submit a state if it is not the USA.
		var state = this.state;
		if(state.country === "UNITED STATES"){
			state.nonUSState = '';
		}
		else{
			this.validateNonUSState(this.state.nonUSState, state);
			state.usState = '';
		}

		this.setState({state});
	}

	validateUSState = (value, state) => {
		if(value === 'Select' || value === ''){
		//state[fieldName].isValid = false;
		  //state[fieldName].message = "Error: Please enter your State / Province.";
		  state.USStateError = "Error: Please select a State.";
		}
		else {
		  state.USStateError = "";
	   }
	   this.setState({
		   state
	   });
	}


	validateNonUSState = (value, state) => {
		const length = value.length;
		if( length < 3 ){
		  state.nonUSStateError = "Error: Please enter your State / Province.";
		}
		else if (length > 100){
		  state.nonUSStateError = "Error: State / Province cannot exceed 100 characters in length.";
		}
		else {
		  state.nonUSStateError = "";
	   }
	   this.setState({
		   state
	   });

	}

	showUSStatesDropdown = () => {
        if(this.state.country === 'Select' || this.state.country === 'UNITED STATES' || this.state.country === '') {
            return true;
        } else {
            return false;
        }
	}

	 validateResponse(response) {
	 	if (!response.ok) {
	 		throw Error(response.statusText);
	 	}
	 	return response;
	 }

	 logResult(result) {
	 	console.log('I love this result .... \n\n\n', result);
	 }

	 handleFormSubmit = (event) => {
		 event.preventDefault();
		 this.handleReconcileCountryState();

	 	if (this.validateForm()) {
			this.setState({
				showSubmitUpgradeOrgRequestModal: true
		    });
	 	}
	 }

	submitUpgradeRequest = (event) => {
		this.handleReconcileCountryState();
		this.setState({
			formErrors: 0,
			showSubmitUpgradeOrgRequestModal: false
		});

		return fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/organization/upgradePersonalAccount', {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': this.state.csrfToken
				},
				body: JSON.stringify({
					organizationName: this.state.organizationName,
					businessEmail: this.state.businessEmail,
					webSite: this.state.webSite,
					businessDescription: this.state.description,
					address1: this.state.address1,
					address2: this.state.address2,
					city: this.state.city,
					state: this.state.usState,
					nonUSStateProvince: this.state.nonUSState,
					country: this.state.country,
					postalCode: this.state.postalCode,
					phone: this.state.phone
				}),
				credentials: 'include'
			})

			.then(response => {
				if (!response.ok) {
					if (response.status === 400) {
						return response.json();
					} else if (response.status === 401) {
						loginRedirect();
						return null;
					}  else if (response.status === 409) {
						this.setState({
							showOrgNameAlreadyExistsErrorModal: true
						});
						return null;
					}
					throw new Error("Unknown Problem occurred : " + response.statusText);
				} else if(response.ok)	{
					pageRedirect("/developer/mvc/organization/manageUsers");
				}
			})

			.then(json => {
				if (json != null) {
					for (var i = 0; i < json.validationErrors.length; i++) {
						this.handleAlignErrors(i, json);
					}

				}
			})
			.catch(error => {
				errorRedirect("request.processing.error");
			})
	}

	validateForm = () => {
		const upgradePersonalAccountOrgForm = this.upgradePersonalAccountOrgForm;
		const formValidationErrors = this.validate(upgradePersonalAccountOrgForm);
		if(formValidationErrors.length > 0)	{
			return false;
		} else{
			return true;
		}
	}

	validate = (upgradePersonalAccountOrgForm) => {
		const formValidationErrors = [];

		const orgNameRegEx = /^(?=.*?[a-zA-Z0-9])[a-zA-Z0-9-.][A-Za-z0-9- .&*$@#!:;=_?%]*[A-Za-z0-9-.&*$@#!:;=_?%]$/;

		const formLength = upgradePersonalAccountOrgForm.length;

		for (let index = 0; index < formLength; index++) {
			const elem = upgradePersonalAccountOrgForm[index];

			if (elem.value === "" && elem.name === 'organizationName') {
				formValidationErrors.push("org name error");
				this.setState({
					organizationNameError: "Error: Please enter a Name.",
				});
			}
			if(elem.value !== "" && elem.name === 'organizationName')	{
				if(!elem.value.match(orgNameRegEx))	{
					formValidationErrors.push("org name regex error");
					this.setState({
						organizationNameError: "Error: Please use only English, alphanumeric characters. Spaces, periods, and these special characters are allowed - & * $ @ # ! : ; = ? _ % (no commas). Other than alphanumeric characters, only . and - are allowed at the beginning. No leading or trailing spaces.",
					});
				}
			}
			if (elem.value === "" && elem.name === 'address1') {
				formValidationErrors.push("address1 error");
				this.setState({
					address1Error: "Error: Please enter an Address."
				});
			}
			if (elem.value === "" && elem.name === 'city') {
				formValidationErrors.push("city error");
				this.setState({
					cityError: "Error: Please enter an City.",
				});
			}

			if (elem.value === "Select" && elem.name === 'country') {
				formValidationErrors.push("country error");
				this.setState({
					countryError: "Error: Please select a Country."
				});
			}

			if (this.state.country === "" && elem.value === "Select" && elem.name === 'usState') {
				formValidationErrors.push("state error");
				this.setState({
					USStateError: "Error: Please select a State."
				});
			}

			if (this.state.country === "UNITED STATES" && elem.name === 'usState' && elem.value === "Select") {
				formValidationErrors.push("us state  error");
				this.setState({
					USStateError: "Error: Please select a State."
				});
			} else if (this.state.country !== "UNITED STATES" && elem.name === 'nonUSState' && elem.value === "") {
				formValidationErrors.push("non us state error");
				this.setState({
					nonUSStateError: "Error: Please select a State or Province."
				});
			}

			if (elem.value === "" && elem.name === 'phone') {
				formValidationErrors.push("phone error");
				this.setState({
					phoneError: "Error: Please enter a Phone Number."
				});
			}
			if (elem.value === "" && elem.name === 'postalCode') {
				formValidationErrors.push("postal code error");
				this.setState({
					postalCodeError: "Error: Please enter a Postal Code."
				});
			}
			if (elem.value === "" && elem.name === 'businessEmail') {
				formValidationErrors.push("business email error");
				this.setState({
					businessEmailError: "Error: Please enter a Business Email."
				});
			}
			if (elem.value === "" && elem.name === 'description') {
				formValidationErrors.push("description error");
				this.setState({
					descriptionError: "Error: Please enter a Business Description."
				});
			}

		}
		return formValidationErrors;
	}

	 handleAlignErrors(location, json) {
		 var field = json.validationErrors[location].field;
		 var errorCode = json.validationErrors[location].errorCode;
		 var fieldErrorName = field + 'Error';
		 if(field === 'phone' && errorCode === "Pattern")	{
			 this.setState({
	 			phoneError: "Error: Please enter a valid Phone Number.",
	 		});
		 } else if(field === 'webSite' && errorCode === "URL")	{
			 this.setState({
	 			webSiteError: "Error: Please enter a valid URL.",
	 		});
		 }  else if(field === 'businessEmail' && errorCode === "Email")	{
			 this.setState({
	 			businessEmailError: "Error: Please enter a valid email address.",
	 		});
		 } else if(field === 'address1' && errorCode === "Pattern")	{
			 this.setState({
	 			address1Error: "Error: Please enter a valid address.",
	 		});
		 } else if(field === 'address2' && errorCode === "Pattern")	{
			 this.setState({
	 			address2Error: "Error: Please enter a valid address.",
	 		});
		 } else if(field === 'city' && errorCode === "Pattern")	{
			 this.setState({
	 			cityError: "Error: Please enter a valid city.",
	 		});
		 } else if(field === 'businessDescription' && errorCode === "Pattern")	{
			 this.setState({
	 			descriptionError: "Error: Please enter a valid description.",
	 		});
		 } else if(field === 'postalCode' && errorCode === "Pattern")	{
			 this.setState({
	 			descriptionError: "Error: Please enter a valid postal code.",
	 		});
		 }
		 else 	{
			 this.setState({
	 			[fieldErrorName]: json.validationErrors[location].message,
			  });
		}
	 }

	 errorClass = (elementName) => {
		var errorName = elementName + 'Error';
	 	return (this.state[errorName] === '' ? 'has-success' : 'has-error');
	 }

	 hideClass(element) {
	 	if (this.state.organizationNameError !== '') {
	 		return 'show';
	 	} else {
	 		return 'hide';
	 	}
	 }
	 
	 handleTooltipClick = (event) => {
		 event.preventDefault();
	 }

	render () {
		return (
				<div className="card-body">
				<div className="row padBottom">
					<div className = "col-sm-6" > < h2 id="orgIdHeading" class = "text-blue-dark form-heading" > <strong> Organizations/Company Details </strong></h2 > </div>
					<div className = "col-sm-6 text-right form-heading"> <strong className = "text-gray-dark" > Required Fields </strong><strong className="text-red"> *</strong ></div>
					<div className = "col-12"><hr/></div>
					<div className = "col-12">Upgrade Individual Account will allow you to add additional organizational users to the account.</div>
				</div>
				<div className="row padBottom">
					<div className="col-12 col-6">
						<form id="upgradePersonalAccountOrgForm" name="upgradePersonalAccountOrgForm" className="customForm" ref={form => (this.upgradePersonalAccountOrgForm = form)} onSubmit={this.handleFormSubmit}>
							<div className="row">
								<div className="col-12">
									<div id="organizationName" className={`form-group server-error ${this.errorClass('organizationName')}`}>
										<label>Organization/Company Name (company, school, government agency, yourself)<strong className="text-red"> *</strong></label>

										<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Please use only English, alphanumeric characters. Spaces, periods, and these special characters are allowed - & * $ @ # ! : ; = ? _ % (no commas). Other than alphanumeric characters, only . and - are allowed at the beginning. No leading or trailing spaces.">
											<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
										</a>

										<FormError errorMessage={this.state.organizationNameError} id={"organizationNameError"}/>
										<div className="row">
											<div className="col-12 col-sm-6">
												<input	className="form-control"
														aria-required="true" aria-describedby="organizationNameError"
														name="organizationName"
														type="text"
														value={this.state.organizationName}
														onChange={this.handleInputChange}
														onBlur={this.handleOnBlurOrgName}
														autoComplete="nope"
														maxLength="50"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="address1" className={`form-group server-error ${this.errorClass('address1')}`}>
										<label>Organization/Company Street Address 1<strong className="text-red"> *</strong></label>
											<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters.">
												<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
											</a>
											<FormError errorMessage={this.state.address1Error} id={"address1Error"}/>
											<div className="row">
												<div className="col-12 col-sm-6">
													<input className="form-control"
														aria-required="true" aria-describedby="address1Error"
														name="address1"
														type="text"
														value={this.state.address1}
														onChange={this.handleInputChange}
														maxLength="100"/>
												</div>
											</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="address2" className={`form-group server-error ${this.errorClass('address2')}`}>
										<label>Organization/Company Street Address 2</label>
											<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters.">
												<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
											</a>
											<FormError errorMessage={this.state.address2Error} id={"address2Error"}/>
											<div className="row">
												<div className="col-12 col-sm-6">
													<input className="form-control" aria-required="true"
														name="address2"
														type="text"
														value={this.state.address2}
														onChange={this.handleInputChange}
														maxLength="100"/>
												</div>
											</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="city" className={`form-group ${this.errorClass('city')}`}>
										<label>City<strong className="text-red"> *</strong></label>
											<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only and use only spaces, hyphens, periods and underscores. Enter no more than one space between characters.">
												<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
											</a>
											<FormError errorMessage={this.state.cityError} id={"cityError"}/>
											<div className="row">
												<div className="col-12 col-sm-6">
													<input className="form-control"
														aria-required="true" aria-describedby="cityError"
														name="city"
														type="text"
														value={this.state.city}
														onChange={this.handleInputChange}
														maxLength="30"/>
												</div>
											</div>
									</div>
								</div>
							</div>
							<CountriesAndStates updateSelectedState={this.setSelectedState} updateSelectedCountry={this.setSelectedCountry} updateSelectedNonUSState={this.setSelectedNonUSState}
                            					countryError={this.state.countryError} usStateError={this.state.USStateError } nonUSStateError={this.state.nonUSStateError}
                            					selectedCountry={this.state.country} selectedState={this.state.usState} selectedNonUSState={this.state.nonUSState}
                              					errorClass={this.errorClass()} showUSStatesDropdown={this.showUSStatesDropdown} disabled={this.state.disabled}/>
							<div className="row">
								<div className="col-12">
									<div id="postalCode" className={`form-group help-block ${this.errorClass('postalCode')}`}>
										<label>Postal Code<strong className="text-red"> *</strong></label>
										<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only and use only spaces, hyphens, periods and underscores. Enter no more than one space between characters.">
											<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
										</a>
										<FormError errorMessage={this.state.postalCodeError} id={"postalCodeError"}/>
										<div className="row">
											<div className="col-12 col-sm-6">
												<input className="form-control"
													aria-required="true" aria-describedby="postalCodeError"
													name="postalCode"
													type="text"
													value={this.state.postalCode}
													onChange={this.handleInputChange}
													maxLength="20"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="phone" className={`form-group ${this.errorClass('phone')}`}>
										<label>Organization/Company Phone<strong className="text-red"> *</strong></label>
										<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only and use only spaces, hyphens.">
											<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
										</a>
										<FormError errorMessage={this.state.phoneError} id={"phoneError"}/>
										<div className="row">
											<div className="col-12 col-sm-6">
												<input className="form-control"
													aria-required="true" aria-describedby="phoneError"
													name="phone"
													type="text"
													value={this.state.phone}
													onChange={this.handleInputChange}
													maxLength="30"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="email" className={`form-group ${this.errorClass('businessEmail')}`}>
										<label>Organization/Company E-mail<strong className="text-red"> *</strong></label>
										<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter a general e-mail address for your organization/company, such as info@company.com.">
											<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
										</a>
										<FormError errorMessage={this.state.businessEmailError} id={"businessEmailError"}/>
										<div className="row">
											<div className="col-12 col-sm-6">
												<input className="form-control"
													aria-required="true" aria-describedby="businessEmailError"
													name="businessEmail"
													type="text"
													value={this.state.businessEmail}
													onChange={this.handleInputChange}/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="webSite" className={`form-group ${this.errorClass('webSite')}`}>
										<label>Organization/Company Website</label>
										<FormError errorMessage={this.state.webSiteError} />
										<div className="row">
											<div className="col-12 col-sm-6">
												<input className="form-control"
													aria-required="true" aria-describedby="webSiteError"
													name="webSite"
													type="text"
													value={this.state.webSite}
													onChange={this.handleInputChange}
													maxLength="250"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									<div id="description" className={`form-group ${this.errorClass('description')}`}>
										<label>Organization/Company Description<strong className="text-red"> *</strong></label>
										<a onClick={this.handleTooltipClick} href="#" tab-index="0" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-placement="top" className="tooltipLink hidden-xs hidden-sm" data-bs-content="Enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters.">
											<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" alt=""/>
										</a>
										<FormError errorMessage={this.state.descriptionError} />
										<div className="row">
											<div className="col-12 col-sm-6">
												<textarea className="form-control"
													aria-required="true" aria-describedby="descriptionError"
													name="description"
													value={this.state.description}
													onChange={this.handleInputChange}
													rows="3"
													maxLength="255"/>
											</div>
										</div>
									</div>
								</div>
							</div>
							<hr/>
							<div className="row">
								<div className="col-sm-6 text-right">
									<div className="form-group">
										<input name="submitButton" id="submitButton" className="button secondary light-bg" type="submit" value="Submit" aria-label="Continue. Clicking Continue will open a dialog"/>
									</div>
								</div>
							</div>
							</form>
						</div>
					</div>
					<OrganizationSearch handleOrgSearchResults={this.handleOrgSearchResults} onRef={ref => (this.child = ref)}/>
					<SelectOrgToJoinModal orgSearchResults={this.state.orgSearchResults} showSelectOrgToJoinModal={this.state.showSelectOrgToJoinModal} handleResponseForOrgJoinRequest={this.handleResponseForOrgJoinRequest} hideSelectOrgToJoinModal={this.hideSelectOrgToJoinModal}/>
					<RequestToJoinOrgErrorMessageModal requestToJoinOrgErrorMessage={this.state.requestToJoinOrgErrorMessage} showRequestToJoinOrgErrorMessageModal={this.state.showRequestToJoinOrgErrorMessageModal} closeRequestToJoinOrgErrorMessageModal={this.closeRequestToJoinOrgErrorMessageModal}/>
					<RequestToJoinOrgSuccessMessageModal showRequestToJoinOrgSuccessMessageModal={this.state.showRequestToJoinOrgSuccessMessageModal} closeRequestToJoinOrgSuccessMessageModal={this.closeRequestToJoinOrgSuccessMessageModal}/>
					<SubmitUpgradeOrgRequestModal showSubmitUpgradeOrgRequestModal={this.state.showSubmitUpgradeOrgRequestModal} submitUpgradeRequest={this.submitUpgradeRequest} hideSubmitUpgradeOrgRequestModal={this.hideSubmitUpgradeOrgRequestModal}/>
					<OrgNameAlreadyExistsErrorModal hideOrgNameAlreadyExistsErrorModal={this.hideOrgNameAlreadyExistsErrorModal} showOrgNameAlreadyExistsErrorModal={this.state.showOrgNameAlreadyExistsErrorModal}/>
				</div>
		)
	}
}

export default UpgradePersonalAccountForm;



// WEBPACK FOOTER //
// ./src/manageMyAccount/UpgradePersonalAccountForm.js